import React, { forwardRef, useEffect, useState } from 'react';

import { Control } from '@vlabs/uikit';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';

function ComparingAttributeFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters, updateFiltersDebounced } = useEventListFilters();

  const [localValue, setLocalValue] = useState<string>('');

  useEffect(() => {
    setLocalValue(filters.top_matching_candidates_label ?? '');
  }, [filters]);

  const handleChange = (value: string) => {
    setLocalValue(value);
    updateFiltersDebounced({ top_matching_candidates_label: value.length > 0 ? value : undefined });
  };

  const reset = () => {
    updateFilters({ top_matching_candidates_label: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.top_matching_candidates_label === undefined}
      onClickReset={reset}
      ref={ref}
      title={<div className="Subtitle-2">{t('comparing_attribute')}</div>}
    >
      <Control.Input
        id="top_matching_candidates_label"
        isClearable
        name="top_matching_candidates_label"
        onChangeValue={handleChange}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const ComparingAttributeFilterPopoverWithRef = forwardRef(ComparingAttributeFilterPopover);
export { ComparingAttributeFilterPopoverWithRef as ComparingAttributeFilterPopover };
